import styled from 'styled-components';
import { useModalsContext } from 'modules/sendingPlatforms/contexts';
import { spacing, H4 } from 'ui/theme';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Add24 } from 'ui/icons';

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.plusHalf};
  white-space: nowrap;
`;

export const Heading = styled(H4)`
  margin-bottom: 0;
  margin-right: ${spacing.base};
`;

export const CustomPushAccountsHeader = () => {
  const { showAddDestinationModal } = useModalsContext();
  return (
    <Header data-test="sending-platform-details-destinations-header">
      <Heading>Destinations</Heading>
      <PrimaryButton
        size={BUTTON_SIZES.LARGE}
        onClick={() => {
          showAddDestinationModal();
        }}
      >
        <Add24 />
        <span>Add destination</span>
      </PrimaryButton>
    </Header>
  );
};
